import script from "./modifyPwd.vue?vue&type=script&setup=true&lang=js"
export * from "./modifyPwd.vue?vue&type=script&setup=true&lang=js"

import "./modifyPwd.vue?vue&type=style&index=0&id=40799611&lang=scss&scoped=true"

import exportComponent from "/data/soft/jenkins/workspace/S09_ehm-acsecurity-pro-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40799611"]])

export default __exports__